<script setup lang="ts">
import ErrorBoundary from '@/components/primitives/ErrorBoundary.vue'
import { Toaster } from '@/components/ui/sonner'
import { useLocale } from '@/i18n/useLocale'
import { useUiStore } from '@/stores/ui.store'
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'

const { applyDocumentLocale, locale } = useLocale()
const ui = useUiStore()

applyDocumentLocale(locale.value)

onMounted(() => {
  ui.setTheme(ui.theme)
})
</script>

<template>
  <ErrorBoundary>
    <RouterView />
  </ErrorBoundary>
  <Toaster position="top-center" rich-colors />
</template>
